import Vue from "vue";
import Dashboard from "./Dashboard.vue";
import BundeslandTable from "./BundeslandTable.vue";
import BundeslandTableKrankenhaus from "./BundeslandTableKrankenhaus.vue";
//import BezirkeSM from './BezirkeSM.vue'
import Reff from "./Reff.vue";
import Sterblichkeit from "./Sterblichkeit.vue";
import * as format from "d3-format";
import Sparkline from "vue-sparklines";
import Chart from "chart.js";

Chart.defaults.global.defaultFontFamily = "Roboto, sans-serif";

Sparkline.install(Vue);

Vue.config.productionTip = false;

const locale = format.formatDefaultLocale({
  decimal: ",",
  thousands: ".",
  grouping: [3],
  currency: ["", "\u00a0€"]
});

Vue.prototype.$fmt = locale.format;
new Vue({
  render: h => h(Dashboard)
}).$mount("#qvvapp");

if (document.querySelector("#qvv_bundesland_table")) {
  new Vue({
    render: h => h(BundeslandTable)
  }).$mount("#qvv_bundesland_table");
}

if (document.querySelector("#qvv_bundesland_table_krankenhaus")) {
  new Vue({
    render: h => h(BundeslandTableKrankenhaus)
  }).$mount("#qvv_bundesland_table_krankenhaus");
}

/*
if(document.querySelector('#qvv_bezirke_sm')) {
  new Vue({
    render: h => h(BezirkeSM),
  }).$mount('#qvv_bezirke_sm')  
}
*/

if (document.querySelector("#qvv_reff")) {
  new Vue({
    render: h => h(Reff)
  }).$mount("#qvv_reff");
}

if (document.querySelector("#qvv_sterblichkeit")) {
  new Vue({
    render: h => h(Sterblichkeit)
  }).$mount("#qvv_sterblichkeit");
}
